import { DownloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const I18N_BASE = 'scenes.visit_history.header';

interface VisitHistoryHeaderProps {
  /** Data is loaded and there is at least one stop. */
  canDownload: boolean;
  exporting: boolean;
  onDownload: () => void;
  /** Otro reporte con el mismo encabezado (título, subtítulo, descarga). */
  i18nBase?: string;
}

/** Title, one-line subtitle and the export action. */
function VisitHistoryHeader({
  canDownload,
  exporting,
  onDownload,
  i18nBase = I18N_BASE,
}: VisitHistoryHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="visit-history-header">
      <div>
        <h1 className="visit-history-header__title">
          {t(`${i18nBase}.title`)}
        </h1>
        <p className="visit-history-header__subtitle">
          {t(`${i18nBase}.subtitle`)}
        </p>
      </div>

      {/* The span lets the tooltip show over a disabled button. */}
      <Tooltip
        title={canDownload ? undefined : t(`${i18nBase}.download_disabled`)}
      >
        <span>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            disabled={!canDownload}
            loading={exporting}
            onClick={onDownload}
          >
            {t(`${i18nBase}.download`)}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}

export default VisitHistoryHeader;
